module.exports = __webpack_public_path__ + "img/palloncini.66428812.jpg";